import { render, staticRenderFns } from "./PlayerLevels.vue?vue&type=template&id=0280bec3&scoped=true"
import script from "./PlayerLevels.vue?vue&type=script&lang=js"
export * from "./PlayerLevels.vue?vue&type=script&lang=js"
import style0 from "./PlayerLevels.vue?vue&type=style&index=0&id=0280bec3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0280bec3",
  null
  
)

export default component.exports